<template>
  <div class="table-dropdown" ref="dropdown">
    <button 
      class="table-bbl-dropdown-trigger"
      @click="toggleDropdown"
      :class="{ 'is-open': isOpen }"
      title="Insert Table"
    >
      <Table />
      <svg class="dropdown-icon" :class="{ 'rotate': isOpen }" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    
    <transition name="dropdown-fade">
      <div v-if="isOpen" class="table-bbl-dropdown-menu">
        <div class="bbl-dropdown-menu-inner">
          <div class="table-grid-container">
            <div class="table-grid">
              <div
                v-for="row in maxRows"
                :key="'row-' + row"
                class="grid-row"
              >
                <div
                  v-for="col in maxCols"
                  :key="'cell-' + row + '-' + col"
                  class="grid-cell"
                  :class="{ 
                    'highlighted': row <= hoveredRows && col <= hoveredCols
                  }"
                  @mouseenter="handleCellHover(row, col)"
                  @click="handleCellClick(row, col)"
                ></div>
              </div>
            </div>
            <div class="grid-label">
              {{ hoveredRows || 0 }} × {{ hoveredCols || 0 }} Table
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Table from '../svg/Table.vue'

export default {
  name: 'TableDropdown',
  components: {
    Table
  },
  emits: ['insert'],
  data() {
    return {
      isOpen: false,
      maxRows: 8,
      maxCols: 8,
      hoveredRows: 0,
      hoveredCols: 0,
      customRows: 3,
      customCols: 3
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.hoveredRows = 0
        this.hoveredCols = 0
      }
    },
    handleCellHover(row, col) {
      this.hoveredRows = row
      this.hoveredCols = col
    },
    handleCellClick(row, col) {
      this.$emit('insert', { rows: row, cols: col })
      this.isOpen = false
      this.hoveredRows = 0
      this.hoveredCols = 0
    },
    handleClickOutside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.isOpen = false
      }
    }
  }
}
</script>

<style scoped>
.table-dropdown {
  position: relative;
  display: inline-block;
}

.table-bbl-dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1.5px solid #e5e7eb;
  border-radius: 6px;
  padding: 6px 10px;
  height: 32px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.table-bbl-dropdown-trigger:hover {
  border-color: #3b82f6;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
  transform: translateY(-1px);
}

.table-bbl-dropdown-trigger.is-open {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  background: white;
}

.table-icon {
  width: 16px;
  height: 16px;
  color: #374151;
}

.dropdown-icon {
  color: #6b7280;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.dropdown-icon.rotate {
  transform: rotate(180deg);
}

.table-bbl-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: white;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1), 0 4px 10px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  overflow: hidden;
}

.table-grid-container {
  text-align: center;
  margin-bottom: 12px;
}

.table-grid {
  display: inline-block;
  padding: 8px;
  background: #f9fafb;
  border-radius: 6px;
  margin-bottom: 8px;
}

.grid-row {
  display: flex;
  gap: 3px;
  margin-bottom: 3px;
}

.grid-row:last-child {
  margin-bottom: 0;
}

.grid-cell {
  width: 20px;
  height: 20px;
  border: 1px solid #d1d5db;
  background: white;
  cursor: pointer;
  transition: all 0.15s ease;
  border-radius: 2px;
}

.grid-cell:hover {
  border-color: #3b82f6;
}

.grid-cell.highlighted {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  border-color: #3b82f6;
}

.grid-label {
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  min-height: 18px;
}

.divider {
  height: 1px;
  background: #e5e7eb;
  margin: 12px 0;
}

.custom-size-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.input-group {
  display: flex;
  gap: 10px;
}

.input-field {
  flex: 1;
}

.input-field label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.size-input {
  width: 100%;
  padding: 6px 8px;
  border: 1.5px solid #e5e7eb;
  border-radius: 6px;
  font-size: 13px;
  box-sizing: border-box;
  transition: all 0.2s;
  font-weight: 500;
}

.size-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.insert-custom-btn {
  width: 100%;
  padding: 8px 12px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

.insert-custom-btn:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
}

.insert-custom-btn:active {
  transform: translateY(0);
}

/* Dropdown animation */
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.dropdown-fade-enter-from {
  opacity: 0;
  transform: translateY(-8px) scale(0.95);
}

.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px) scale(0.98);
}
</style>
